import { useMemo } from 'react';
import { SECTION_IDS } from '../constants';

export const useSectionToggles = (
  onSectionToggle?: (sectionId: string, isOpen: boolean) => void
) => {
  return useMemo(() => {
    const make = (sectionId: string) => (isOpen: boolean) =>
      onSectionToggle?.(sectionId, isOpen);
    return {
      basicInfo: make(SECTION_IDS.basicInfo),
      applicationContent: make(SECTION_IDS.applicationContent),
      transactionsDetail: make(SECTION_IDS.transactionsDetail),
      journalInfo: make(SECTION_IDS.journalInfo),
    };
  }, [onSectionToggle]);
};
